export const gridSize = 24;

export const fontColour = "#04153e";

export const lightGrey = "#aaa";

export const smallScreenThreshold = "900px";
